/**
 * server
 * response.life.edu Backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TokenResponse { 
    /**
     * User account name email-like
     */
    user?: string;
    /**
     * List of groups/scopes the user belongs to.
     */
    role?: string;
    /**
     * Number of seconds the token is valid
     */
    expires_in?: number;
    access_token?: string;
    refresh_token?: string;
    token_type?: string;
}

